import React from "react";

const LoadingElevaty = ({
  width = "60px",
  height = "60px",
  duration = "durDefault",
  useSizeProps = false,
}) => {
  const durDefault = "3.0058062130189507s";
  const durFast = "1.0058062130189507s";

  const animationDuration = duration === "durFast" ? durFast : durDefault;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={useSizeProps ? width : "50"}
      height={useSizeProps ? height : "50"}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#2942a8"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
      >
        <animate
          attributeType="XML"
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur={animationDuration}
          values="0,0,125.6,31.4;
                0,31.4,125.6,0;
                125.6,31.4,0,0"
          keyTimes="0; 0.24208638305104102; 1"
          begin="0s"
        />
      </circle>
    </svg>
  );
};

export default LoadingElevaty;
